module.exports = __webpack_public_path__ + "static/img/ic_gy_d_b@2x.f3b49285.png";